import { LOCATION_CHANGE } from 'react-router-redux';

import {
  OPTIONS_LOADED,
  SELECT_MATERIAL,
  SELECT_EXPRESSION,
  SELECT_COVER_PANEL,
  SELECT_EDGE,
  SELECT_WALL_LOCATION,
  SELECT_KITCHEN_ISLAND_WALL_LOCATION,
  SELECT_KITCHEN_ISLAND,
  SELECT_THICKNESS,
  SELECT_SPLASHBACK,
  SELECT_WALL_PANEL_EXPRESSION,
  SELECT_WALL_PANEL_MATERIAL,
  SELECT_SINK_MATERIAL,
  SELECT_SINK_MODEL,
  SELECT_SINK_FASTENING,
  SELECT_DRAINER_GROOVES,
  CHANGE_SHAPE,
  RESET_PLAN,
  CHANGE_CUTOUTS,
  REVERT_PLAN,
  UNDO_CHOICE,
  PARAMETER_SEEN,
  CHANGE_SINGLE_CUTS,
  CHANGE_DOUBLE_CUTS,
  CHANGE_TRIPLE_CUTS,
  CHANGE_HIGH_CABINET_JOINTS,
  CHANGE_ROUNDED_CORNERS,
  CHANGE_INVERTED_CORNERS,
  CHANGE_TAP_HOLES,
  CHANGE_DEFAULT_SHAPE,
  RESET_NUMERICAL_PARAMETER,
  CHANGE_WALL_PANEL_ROUND_CUTS_SMALL,
  CHANGE_WALL_PANEL_ROUND_CUTS_BIG,
  CHANGE_WALL_PANEL_SQUARE_CUTS,
  CHANGE_WALL_PANEL_SINGLE_CUTS,
  CHANGE_WALL_PANEL_DOUBLE_CUTS,
  CHANGE_WALL_PANEL_TRIPLE_CUTS,
  SELECT_KITCHEN_ISLAND_MATERIAL,
  SELECT_KITCHEN_ISLAND_EXPRESSION,
  SELECT_KITCHEN_ISLAND_EDGE,
  SELECT_KITCHEN_ISLAND_THICKNESS,
  SELECT_KITCHEN_ISLAND_SAME_AS_WORKTOP,
  SELECT_OVERHANG,
  SELECT_OVERHANG_SIDE,
  SELECT_WALL_PANEL_MATCH_WORKTOP,
  CHANGE_FREESTANDING_HOBS,
  SELECT_KITCHEN_ISLAND_OVERHANG_SIDE,
  SELECT_KITCHEN_ISLAND_OVERHANG,
  CHANGE_KITCHEN_ISLAND_SINGLE_CUTS,
  CHANGE_KITCHEN_ISLAND_ROUNDED_CORNERS,
  CHANGE_KITCHEN_ISLAND_SQUARE_CUTS,
} from '../constants';
import { planHasUnavailableOptions } from '../selectors/resolver';


function revertPlan(state, type, saveCurrentPlan) {
  if (!state.getIn(['previous', 'plan']) || state.getIn(['previous', 'plan', 'conflictMode'])) {
    return state;
  }

  const stateWithUpdatedPlan = state.set('plan', state.getIn(['previous', 'plan']))
    .setIn(['plan', 'lastAction'], type)
    .set('shapesFlipped', state.getIn(['previous', 'shapesFlipped']))
    .set('kitchenIslandFlipped', state.getIn(['previous', 'kitchenIslandFlipped']))
    .set('planCode', state.getIn(['previous', 'planCode']))
    .set('shapeFields', state.getIn(['previous', 'shapeFields']));

  if (saveCurrentPlan) {
    const currentPlan = state.get('plan');
    const currentShapesFlipped = state.get('shapesFlipped');
    const currentKitchenIslandFlipped = state.get('kitchenIslandFlipped');

    return stateWithUpdatedPlan.setIn(['previous', 'plan'], currentPlan)
      .setIn(['previous', 'shapesFlipped'], currentShapesFlipped)
      .setIn(['previous', 'kitchenIslandFlipped'], currentKitchenIslandFlipped)
      .setIn(['previous', 'planCode'], state.get('planCode'))
      .setIn(['previous', 'shapeFields'], state.get('shapeFields'));
  } else {
    return stateWithUpdatedPlan;
  }
}

function resetLastAction(state, action) {
  return state.setIn(['plan', 'lastActionUpdatedPlan'], false).setIn(['plan', 'lastAction'], action.type);
}


function setPrevious(state) {
  return state.setIn(['previous', 'plan'], state.get('plan'))
    .setIn(['previous', 'shapesFlipped'], state.get('shapesFlipped'))
    .setIn(['previous', 'kitchenIslandFlipped'], state.get('kitchenIslandFlipped'))
    .setIn(['previous', 'planCode'], state.get('planCode'))
    .setIn(['previous', 'shapeFields'], state.get('shapeFields'));
}

function revertToLastReducer(state, action) {
  let stateWithSavedPlan;
  const stateWithResetLastAction = resetLastAction(state, action);

  if (!state.getIn(['plan', 'conflictMode']) && !planHasUnavailableOptions(state.get('plan'))) {
    stateWithSavedPlan = resetLastAction(setPrevious(state), action);
  } else {
    stateWithSavedPlan = stateWithResetLastAction;
  }

  switch (action.type) {
    case RESET_PLAN:
    case OPTIONS_LOADED:
    case SELECT_MATERIAL:
    case SELECT_EXPRESSION:
    case SELECT_COVER_PANEL:
    case SELECT_EDGE:
    case SELECT_WALL_LOCATION:
    case SELECT_KITCHEN_ISLAND_WALL_LOCATION:
    case SELECT_KITCHEN_ISLAND:
    case SELECT_KITCHEN_ISLAND_SAME_AS_WORKTOP:
    case SELECT_KITCHEN_ISLAND_MATERIAL:
    case SELECT_KITCHEN_ISLAND_EXPRESSION:
    case SELECT_KITCHEN_ISLAND_EDGE:
    case SELECT_KITCHEN_ISLAND_THICKNESS:
    case SELECT_KITCHEN_ISLAND_OVERHANG:
    case SELECT_KITCHEN_ISLAND_OVERHANG_SIDE:
    case SELECT_OVERHANG:
    case SELECT_OVERHANG_SIDE:
    case SELECT_THICKNESS:
    case SELECT_SPLASHBACK:
    case SELECT_WALL_PANEL_MATCH_WORKTOP:
    case SELECT_WALL_PANEL_MATERIAL:
    case SELECT_WALL_PANEL_EXPRESSION:
    case SELECT_SINK_MATERIAL:
    case SELECT_SINK_MODEL:
    case SELECT_SINK_FASTENING:
    case SELECT_DRAINER_GROOVES:
    case CHANGE_SHAPE:
    case CHANGE_CUTOUTS:
    case CHANGE_SINGLE_CUTS:
    case CHANGE_DOUBLE_CUTS:
    case CHANGE_TRIPLE_CUTS:
    case CHANGE_HIGH_CABINET_JOINTS:
    case CHANGE_ROUNDED_CORNERS:
    case CHANGE_INVERTED_CORNERS:
    case CHANGE_TAP_HOLES:
    case CHANGE_WALL_PANEL_ROUND_CUTS_SMALL:
    case CHANGE_WALL_PANEL_ROUND_CUTS_BIG:
    case CHANGE_WALL_PANEL_SQUARE_CUTS:
    case CHANGE_WALL_PANEL_SINGLE_CUTS:
    case CHANGE_WALL_PANEL_DOUBLE_CUTS:
    case CHANGE_WALL_PANEL_TRIPLE_CUTS:
    case CHANGE_KITCHEN_ISLAND_SINGLE_CUTS:
    case CHANGE_KITCHEN_ISLAND_ROUNDED_CORNERS:
    case CHANGE_KITCHEN_ISLAND_SQUARE_CUTS:
    case CHANGE_FREESTANDING_HOBS:
    case RESET_NUMERICAL_PARAMETER:
      return stateWithSavedPlan;


    case REVERT_PLAN:
      return revertPlan(state, action.type, true);
    case UNDO_CHOICE:
      return revertPlan(state, action.type, false);

    case PARAMETER_SEEN:
    case CHANGE_DEFAULT_SHAPE:
    case LOCATION_CHANGE:
      return stateWithResetLastAction;

    default:
      return state;
  }
}

export default revertToLastReducer;
